export default __webpack_public_path__ + "static/media/folder_icon.a9d5f725.svg";